import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetMappingDeviceConfigurationDevicesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.MappingDeviceConfigurationDeviceFilterInput>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Types.MappingDeviceConfigurationDeviceSortInput> | Types.MappingDeviceConfigurationDeviceSortInput>;
}>;


export type GetMappingDeviceConfigurationDevicesQuery = { mappingDeviceConfigurationDevices?: Maybe<{ __typename?: 'MappingDeviceConfigurationDeviceCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'MappingDeviceConfigurationDevice', id: string, userId?: Maybe<string>, deviceId: string, deviceConfigurationId: string, dateTo: string, dateFrom: string, mappingDeviceConfigurationDeviceStatus: { __typename?: 'MappingDeviceConfigurationDeviceStatus', statusName: string }, deviceConfiguration: { __typename?: 'DeviceConfiguration', id: string, configurationJSON: string } }>> }> };


export const GetMappingDeviceConfigurationDevicesDocument = gql`
    query getMappingDeviceConfigurationDevices($where: MappingDeviceConfigurationDeviceFilterInput, $take: Int, $skip: Int, $order: [MappingDeviceConfigurationDeviceSortInput!]) {
  mappingDeviceConfigurationDevices(where: $where, take: $take, skip: $skip, order: $order) {
    totalCount
    items {
      id
      userId
      deviceId
      deviceConfigurationId
      dateTo
      dateFrom
      mappingDeviceConfigurationDeviceStatus {
        statusName
      }
      deviceConfiguration {
        id
        configurationJSON
      }
    }
  }
}
    `;

/**
 * __useGetMappingDeviceConfigurationDevicesQuery__
 *
 * To run a query within a React component, call `useGetMappingDeviceConfigurationDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMappingDeviceConfigurationDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMappingDeviceConfigurationDevicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetMappingDeviceConfigurationDevicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMappingDeviceConfigurationDevicesQuery, GetMappingDeviceConfigurationDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMappingDeviceConfigurationDevicesQuery, GetMappingDeviceConfigurationDevicesQueryVariables>(GetMappingDeviceConfigurationDevicesDocument, options);
      }
export function useGetMappingDeviceConfigurationDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMappingDeviceConfigurationDevicesQuery, GetMappingDeviceConfigurationDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMappingDeviceConfigurationDevicesQuery, GetMappingDeviceConfigurationDevicesQueryVariables>(GetMappingDeviceConfigurationDevicesDocument, options);
        }
export type GetMappingDeviceConfigurationDevicesQueryHookResult = ReturnType<typeof useGetMappingDeviceConfigurationDevicesQuery>;
export type GetMappingDeviceConfigurationDevicesLazyQueryHookResult = ReturnType<typeof useGetMappingDeviceConfigurationDevicesLazyQuery>;
export type GetMappingDeviceConfigurationDevicesQueryResult = Apollo.QueryResult<GetMappingDeviceConfigurationDevicesQuery, GetMappingDeviceConfigurationDevicesQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
